import { isString } from "lodash";
import PropTypes from "prop-types";
import React from "react";

import { withCharacterContext } from "../../../components/character/CharacterContext";
import { CSV_IMPORT_TABLE_CELL_MAX_WIDTH, CSV_IMPORT_TABLE_CELL_MIN_WIDTH } from "../../../constants/importExportFile";
import { PropTypeShapes } from "../../../types";
import { calcWordWidth } from "../../../utils/calcTextSize";

const minWidth = CSV_IMPORT_TABLE_CELL_MIN_WIDTH;
const maxWidth = CSV_IMPORT_TABLE_CELL_MAX_WIDTH;

const getActualWidth = (setWidth, childrenWidth) => {
  return Math.min(maxWidth, Math.max(minWidth, setWidth, childrenWidth));
};

const ImportCsvTableCell = ({
  children,
  firstRow,
  firstColumn,
  characterContext,
  isHeader,
  isData,
  width,
  onGetNewWidth
}) => {
  const classes = [
    "importCsvTableCell",
    firstRow ? "firstRow" : "",
    firstColumn ? "firstColumn" : "",
    isHeader ? "isHeader" : "",
    isData ? "isData" : ""
  ];

  const childrenWidth = isString(children)
    ? calcWordWidth(children, characterContext.getFontSize(), characterContext.getWidthMap())
    : 0;

  const actualWidth = getActualWidth(width, childrenWidth);

  // Should report the new bigger width
  if (actualWidth > width) {
    onGetNewWidth(actualWidth);
  }

  const styles = { width: `${actualWidth}px` };

  return (
    <div className={classes.join(" ")} style={styles}>
      {children}
    </div>
  );
};

ImportCsvTableCell.defaultProps = {};

ImportCsvTableCell.propTypes = {
  children: PropTypeShapes.elementOrArrayOrString.isRequired,
  isHeader: PropTypes.bool,
  isData: PropTypes.bool,
  firstRow: PropTypes.bool,
  firstColumn: PropTypes.bool,
  onGetNewWidth: PropTypes.func,
  width: PropTypes.number,
  // From character context
  characterContext: PropTypes.object.isRequired
};

export default withCharacterContext(ImportCsvTableCell);
